export enum TokenStatus {
  EMPTY,
  STAY,
  EXPIRED,
}
